import React from 'react';
import { CheckIcon, MailIcon, PrinterIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
import { HERO_IMAGE, heroBullets } from '../data/content';
export function Hero() {
  return <header className="border-b border-line bg-cream" data-id="element-113" data-mp="9ll8uwe5pwmz">
      <div className="mx-auto grid max-w-6xl gap-14 px-5 py-16 lg:grid-cols-[1.05fr_0.95fr] lg:items-start lg:gap-16 lg:py-24" data-id="element-114" data-mp="4lyw0o28qiep">
        <div data-id="element-115" data-mp="128frdnreylxt">
          <p className="font-display text-sm font-semibold uppercase tracking-[0.28em] text-accent" data-id="element-116" data-mp="1286262e70it6">
            El Profe de Guitarra
          </p>

          <h1 className="mt-6 font-display text-4xl font-semibold leading-[1.05] tracking-tight text-ink sm:text-5xl lg:text-6xl" data-id="element-117" data-mp="sbb1pdyd08c9">
            Dejá de perder tus domingos preparando clases.
          </h1>

          <p className="mt-6 font-display text-xl italic leading-snug text-ink-soft sm:text-2xl" data-id="element-118" data-mp="3d1a8vl7kyddt">
            El sistema todo-en-uno «Imprimí y enseñá» para profes de piano y guitarra.
          </p>

          <p className="mt-6 max-w-prose text-[15px] leading-relaxed text-ink-soft" data-id="element-119" data-mp="3j8sezzr63hpb">
            Accedé a más de 300 páginas listas para imprimir con ejercicios, planes de clase
            estructurados y herramientas de estudio. Todo es PDF — sin videos, sin audiolibros —
            y llega a tu email en el momento en que lo compras.
          </p>

          <ul className="mt-8 grid gap-x-6 gap-y-3 sm:grid-cols-2" data-id="element-120" data-mp="3e7uzjuxjl1ri">
            {heroBullets.map(bullet => <li key={bullet} className="flex items-start gap-2.5 text-[15px] text-ink" data-id="element-121" data-mp="30fy9rxjcj3ya">
                <CheckIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-accent" data-id="element-122" data-mp="35a2h4hwixdzw" />
                <span data-id="element-123" data-mp="2qlogmdmky1mi">{bullet}</span>
              </li>)}
          </ul>

          <div className="mt-10 max-w-md" data-id="element-124" data-mp="2vjpvemcz3es6">
            <CtaButton data-id="element-125" data-mp="2hj5ejvqmbt1b">¡Sí! Quiero el pack — acceso ahora por $27.990</CtaButton>
            <p className="mt-3 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-ink-mute" data-id="element-126" data-mp="2hl9rt4aeq4e9">
              <ShieldCheckIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-127" data-mp="2lmuyu909fogj" />
              Pago seguro
              <span aria-hidden="true" data-id="element-128" data-mp="s44e5chl11cm">·</span>
              <MailIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-129" data-mp="nb1imyt8vhts" />
              PDFs por email
              <span aria-hidden="true" data-id="element-130" data-mp="ibgod1p0rxne">·</span>
              Garantía de 7 días
            </p>
          </div>
        </div>

        <figure className="relative" data-id="element-131" data-mp="deq7ic5e4y0x">
          <div className="overflow-hidden rounded-2xl border border-line bg-paper shadow-card" data-id="element-132" data-mp="1b0vwnjpavcfm">
            <img src={HERO_IMAGE} alt="Fichas de piano y planes de clase impresos sobre un escritorio junto a una tablet con una partitura" className="h-full w-full object-cover" data-id="element-133" data-mp="1ayjf37ngf433" />
          </div>
          <figcaption className="mt-4 flex items-center gap-2 text-xs uppercase tracking-eyebrow text-ink-mute" data-id="element-134" data-mp="x0crckc7ykh5">
            <PrinterIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-135" data-mp="3lui86njf0tjs" />
            6 volúmenes · Imprimí copias ilimitadas
          </figcaption>
        </figure>
      </div>
    </header>;
}